// extracted by mini-css-extract-plugin
module.exports = {"incompleteAssignmentsContainer":"styles_incompleteAssignmentsContainer__1JDTJ","loadMoreButtonContainer":"styles_loadMoreButtonContainer__UA07B"};